import React, { useState, useEffect } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { TEMPLATES, getTemplateComponent } from '../components/templates';

const API = process.env.REACT_APP_BACKEND_URL;

const EUBusinessPublic = () => {
  const { slug } = useParams();
  const [searchParams] = useSearchParams();
  const previewTemplate = searchParams.get('template');
  
  const [business, setBusiness] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    loadBusiness();
  }, [slug]);

  const loadBusiness = async () => {
    try {
      setLoading(true);
      
      // Se tem template no query param, é preview
      if (previewTemplate) {
        const response = await fetch(`${API}/api/eu/demo/preview/${slug}/${previewTemplate}`);
        if (response.ok) {
          const data = await response.json();
          setBusiness(data);
          setLoading(false);
          return;
        }
      }
      
      // Carrega business normal
      const response = await fetch(`${API}/api/eu/businesses/${slug}`);
      
      if (response.ok) {
        const data = await response.json();
        setBusiness(data);
      } else if (response.status === 404) {
        // Se não encontrar, tenta criar demo Carlos
        if (slug === 'carlos-electricidad') {
          await fetch(`${API}/api/eu/demo/carlos-electricidad`, { method: 'POST' });
          const retryResponse = await fetch(`${API}/api/eu/businesses/${slug}`);
          if (retryResponse.ok) {
            const data = await retryResponse.json();
            setBusiness(data);
          } else {
            setError('Negocio no encontrado');
          }
        } else {
          setError('Negocio no encontrado');
        }
      } else {
        setError('Error al cargar el negocio');
      }
    } catch (err) {
      console.error('Error loading business:', err);
      setError('Error de conexión');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-slate-950 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin w-10 h-10 border-4 border-blue-500 border-t-transparent rounded-full mx-auto mb-4" />
          <p className="text-white/60">Cargando página...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-slate-950 flex items-center justify-center p-4">
        <div className="text-center max-w-md">
          <div className="w-20 h-20 rounded-full bg-red-500/10 flex items-center justify-center mx-auto mb-6">
            <span className="text-4xl">😕</span>
          </div>
          <h1 className="text-2xl font-bold text-white mb-3">Página no encontrada</h1>
          <p className="text-white/60 mb-6">{error}</p>
          <a 
            href="/"
            className="inline-flex items-center justify-center px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
          >
            Volver al inicio
          </a>
        </div>
      </div>
    );
  }

  if (!business) {
    return null;
  }

  // Determina qual template usar
  const templateId = previewTemplate || business.design_settings?.template_id || 'madrid';
  const TemplateComponent = getTemplateComponent(templateId);

  return <TemplateComponent business={business} />;
};

export default EUBusinessPublic;
